import { useState, useCallback } from 'react';
export default function useTooltip(/** Optional initial TooltipState. */
initialTooltipState) {
  const [tooltipState, setTooltipState] = useState({
    tooltipOpen: false,
    ...initialTooltipState
  });
  const showTooltip = useCallback(showArgs => setTooltipState(typeof showArgs === 'function' ? _ref => {
    let {
      tooltipOpen,
      ...show
    } = _ref;
    return {
      ...showArgs(show),
      tooltipOpen: true
    };
  } : {
    tooltipOpen: true,
    tooltipLeft: showArgs.tooltipLeft,
    tooltipTop: showArgs.tooltipTop,
    tooltipData: showArgs.tooltipData
  }), [setTooltipState]);
  const hideTooltip = useCallback(() => setTooltipState({
    tooltipOpen: false,
    tooltipLeft: undefined,
    tooltipTop: undefined,
    tooltipData: undefined
  }), [setTooltipState]);
  return {
    tooltipOpen: tooltipState.tooltipOpen,
    tooltipLeft: tooltipState.tooltipLeft,
    tooltipTop: tooltipState.tooltipTop,
    tooltipData: tooltipState.tooltipData,
    updateTooltip: setTooltipState,
    showTooltip,
    hideTooltip
  };
}